import { render, staticRenderFns } from "./company-order-detail.vue?vue&type=template&id=eed3eac6"
import script from "./company-order-detail.vue?vue&type=script&lang=js"
export * from "./company-order-detail.vue?vue&type=script&lang=js"
import style0 from "./company-order-detail.vue?vue&type=style&index=0&id=eed3eac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports